import React from "react";
import { useTranslation } from "react-i18next";
import { Minus, Plus } from "lucide-react";

import { cn } from "../../lib/utils";
import { Tone, tones } from "./tones";

interface Props {
  value: number;
  min?: number;
  max: number;
  onChange: (value: number) => void;
  tone?: Tone;
  label?: string;
}

export default function PassengerStepper({
  value,
  min = 1,
  max,
  onChange,
  tone = "light",
  label = "Passageiros",
}: Props) {
  const { t } = useTranslation();
  const c = tones[tone];
  return (
    <div className="inline-flex items-center gap-3" role="group" aria-label={label}>
      <button
        type="button"
        aria-label={t("quote.decrement")}
        className={cn(c.stepperButton, "inline-flex items-center justify-center")}
        disabled={value <= min}
        onClick={() => onChange(value - 1)}
      >
        <Minus className="h-4 w-4" />
      </button>
      <span
        className={cn("min-w-[2.5rem] text-center text-2xl font-bold tabular-nums", c.text)}
        aria-live="polite"
      >
        {value}
      </span>
      <button
        type="button"
        aria-label={t("quote.increment")}
        className={cn(c.stepperButton, "inline-flex items-center justify-center")}
        disabled={value >= max}
        onClick={() => onChange(value + 1)}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
